<template>
  <open-banking-description-step class="obk-description-id-note-step" :step-number="stepNumber">
    <template v-slot:text>
      <div>חשוב לשים לב שמספר הת.ז של בעל הכרטיס באתר חברת האשראי הוא אותו מספר שהקלדת ברייזאפ</div>
    </template>
  </open-banking-description-step>
</template>

<script>
import OpenBankingDescriptionStep from '@/base-components/onboarding/openBanking/OpenBankingDescriptionStep';

export default {
  name: 'ObkDescriptionIdNoteStep',
  components: {
    OpenBankingDescriptionStep,
  },
  props: {
    stepNumber: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
